import "./brokerCryptoButton.scss";
// @vendors
import React from "react";
import PropTypes from "prop-types";
// @enumerations
import CryptoButtonTypeEnum from "./enums/brokerCryptoButton.enumerations";

const CryptoButton = ({
    variant = CryptoButtonTypeEnum.PRIMARY,
    onClick,
    children,
    extraClass = "",
    disabled = false,
}) => {
    const classList = [
        "crypto-button",
        extraClass,
        variant === CryptoButtonTypeEnum.PRIMARY && "crypto-button__primary",
        variant === CryptoButtonTypeEnum.SECONDARY && "crypto-button__secondary",
        disabled && "crypto-button--disabled"
    ].filter(Boolean).join(" ");

    return (
        <button 
            className={classList} 
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

CryptoButton.propTypes = {
    variant: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
    extraClass: PropTypes.string,
};

export { CryptoButton };
